(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["events"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('presale-toggle')) {
    customElements.define('presale-toggle', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('button').addEventListener('click', () => {
          const details = document.getElementById(this.dataset.target)
          if (!details) return
          const content = details.querySelector('.js-events-metaobject__item-details-content')
          if (!details.open) {
            details.open = true
            content.animate([{ height: 0 }, { height: content.scrollHeight + "px" }], {
              duration: 300,
              easing: "ease-out",
            })
          } else {
            const animation = content.animate([{ height: content.scrollHeight + "px" }, { height: 0 }], {
              duration: 300,
              easing: "ease-in-out",
            })
            animation.onfinish = () => details.open = false
          }
        })
      }
    })
  }

  class PresaleCodeReadout extends HTMLElement {
    constructor() {
      super()
      this.presaleCode = false
      this.totalRetryCount = 0
      this.maxRetries = 10
      this.retryFactor = 5
      this.helpTextUpdateInterval = 0
      this.loadingMessageText = "Loading your code..."
    }

    connectedCallback() {
      this.codeRetrievalUrl = this.getAttribute("code-retrieval-url")
      this.render()
    }

    moreRetriesPossible() {
      return this.totalRetryCount < this.maxRetries
    }

    retryCodeRetrieval() {
      if (!this.moreRetriesPossible()) {
        console.log("Giving up on retries")
        window.clearInterval(this.helpTextUpdateInterval)
        this.updateErrorText()
        return
      }

      const msToWait = (2 ** this.totalRetryCount * this.retryFactor) * 1000
      this.nextRetryAttemptAt = (new Date()).getTime() + msToWait
      console.log("Starting retry loop, Waiting...", msToWait)
      window.setTimeout(this.loadPresaleCode.bind(this), msToWait)

      if (!this.helpTextUpdateInterval) {
        this.helpTextUpdateInterval = window.setInterval(this.updateErrorText.bind(this), 1000)
      }
    }

    async loadPresaleCode() {
      try {
        this.totalRetryCount++
        this.textContent = this.loadingMessageText

        if (window.location.hash.includes('test__code-retrieve-fail')) {
          throw "Code retrieval failed because the URL indicates you wanted to test the error scenario."
        }

        const fetchResult = await fetch(this.codeRetrievalUrl)
        const apiResponse = await fetchResult.json()
        if (!apiResponse || apiResponse.error) {
          return this.onPresaleCodeError(apiResponse.error)
        }
        this.presaleCode = apiResponse.code_string.trim()
        this.onPresaleCodeRetrieved()
      } catch(e) {
        this.onPresaleCodeError(e.message)
      }
    }

    updateErrorText() {
      if (this.moreRetriesPossible()) {
        var retryTimer = Math.floor((this.nextRetryAttemptAt - (new Date()).getTime()) / 1000)
        var retryCount = `${this.totalRetryCount} time`
        if (this.totalRetryCount > 1) {
          retryCount += "s"
        }
        var nextStepsMessage = `Hold on. We've tried ${retryCount}, but we'll try again in ${retryTimer} seconds...`
      } else {
        var nextStepsMessage = `Sorry, we tried ${this.totalRetryCount} times but it's still not working.<br/>You can try refreshing the page or <a href='/pages/contact'>click here to contact us for help.</a>`
      }
      this.errorTextContainer.innerHTML = nextStepsMessage
    }

    onPresaleCodeRetrieved() {
      this.innerHTML = `<p class="presale-code__text">Your unique presale code is</p><p class="presale-code__string">${this.presaleCode}</p><p class="presale-code__footer">Don't share this code &mdash; it's unique to you and can only be used once</p>`
      this.setAttribute('data-presale-code', this.presaleCode)
      this.dispatchEvent(
        new CustomEvent("presale-code:available", {
          bubbles: true,
          detail: { presaleCode: () => this.presaleCode },
        })
      )
    }

    onPresaleCodeError(errorMessage) {
      this.innerHTML = `<p class="presale-code__text">Oh no! An unexpected error occurred when fetching your presale code</p>`
      this.errorTextContainer = document.createElement('span')
      this.errorTextContainer.classList.add('presale-retrieval-error-status')
      this.appendChild(this.errorTextContainer)
      this.retryCodeRetrieval()
    }

    render() {
      this.textContent = this.loadingMessageText
      this.loadPresaleCode()
    }
  }

  window.customElements.define('presale-code-readout', PresaleCodeReadout)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nav-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.nav-menu__list-item').forEach(item => {
  const link = item.querySelector('.nav-menu__list-link[aria-haspopup="true"]');
  if (!link) return;
  let touchedOnce = false;
  const openMenu = () => link.setAttribute('aria-expanded', 'true');
  const closeMenu = () => {
    link.setAttribute('aria-expanded', 'false');
    touchedOnce = false;
  };
  link.addEventListener('touchstart', e => {
    if (!touchedOnce) {
      e.preventDefault();
      link.focus();
      touchedOnce = true;
      openMenu();
    } else {
      window.location.href = link.getAttribute('href');
    }
  });
  item.addEventListener('mouseenter', openMenu);
  item.addEventListener('touchstart', openMenu);
  item.addEventListener('mouseleave', closeMenu);
  document.addEventListener('touchstart', e => {
    if (!item.contains(e.target)) closeMenu();
  });
});
  } catch(e) { console.error(e); }
})();

})();
